import { OvErrorBoundary, OvModal } from '@components'
import { URL_PATHS } from '@constants'
import { useStore } from '@hooks/useStore'
import { observer } from 'mobx-react-lite'
import { Navigate, Outlet, ScrollRestoration } from 'react-router-dom'

export const DefaultWithoutMenu = observer(() => {
  const { auth } = useStore()

  // Only check authentication, not company status
  // This layout is used for onboarding where users might not have a company yet
  if (!auth.is_authenticated) {
    return <Navigate to={URL_PATHS.LOGIN} />
  }

  return (
    <>
      <ScrollRestoration />
      <main>
        <OvErrorBoundary>
          <Outlet />
        </OvErrorBoundary>
      </main>
      <OvModal />
    </>
  )
})
